import {React, useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Banner from "../Components/Banner";
import career_banner from "../images/career/career_banner.png"

function Career () {

  useEffect(()=>{
    AOS.init({duration:1000});
  }, [])

    return(
    <>
        <Banner
          img = {career_banner}
          alt = "Banner-Image"
          heading = "Unlock Opportunities with Lands and Lands "
          subheading = "You Next Step towards Growth"
          button = "Know More"
          textposition={"w-[700px] top-48 left-24 "}
        />
        
        <div className="max-w-4xl mx-auto px-4 my-10 text-center font-[merriweather]">
            <h2 className="section-heading mt-6 py-8" data-aos="fade-up">Carriers with Lands & Lands</h2>
            <p className="text-[#757575] font-[merriweather] text-[20px] font-normal leading-[31px] tracking-[0.48px]" data-aos="fade-up" data-aos-duration="1100">We believe that every day is an opportunity to learn, innovate, optimise and grow. We strive to create an inclusive environment with a conviction that diverse perspectives lead to better ideas, stronger decisions and improved outcomes. If you are a passionate indivudual who shares our values, join Lands and Lands to be a part of a team that's shaping the future of Real Estate.</p>
        </div>

        <div className="max-w-[1323px] mx-auto px-6 py-10 md:py-[95px] flex flex-wrap justify-between">

          {/* first div */}
          <div className="max-w-[665px] font-[lato] mx-auto" data-aos="fade-up">
              <h1 className="font-[merriweather] text-[32px] leading-[41px]">Sales Executive</h1>
              <h1 className="font-[merriweather] text-[32px] leading-[41px]">Location : Coimbatore</h1>
              <p className="text-[20px] text-font-grey leading-[28px] tracking-[0.2px] mt-6 font-[lato]">Your journey to new heights in real estate starts here, with Lands and Lands. As a Sales Executive, you'll be more than a team member; you'll be the driving force behind successful property transactions. At Lands and Lands, success is not just a goal; it's a personal journey marked by your passion, ownership and commitment to doing what's right for our clients, people and communities.</p>

          
              <h1 className="font-[merriweather] text-[24px] py-4" data-aos="fade-up">If you are</h1>
              {/* <ul className="ml-6" style={{listStyle:'disc'}} data-aos="fade-up">
                  <li className="career-listing-items">As a key member of our team, you will interface primarily with the Subject Matter Experts, UI designers, and web developers to implement solutions defined during your meetings.</li>
                  <li className="career-listing-items">Develop and facilitate functional requirements use cases and workflows.</li>
                  <li className="career-listing-items">Create mock-ups for various web sites and applications.</li>
                  <li className="career-listing-items">Exhibit outstanding technical and business friendly communication skills and be able to create strong rapport with team members and vendors.</li>
                  <li className="career-listing-items">Exhibit experience in defining and facilitating requirements</li>
                  
              </ul> */}
              <p className='w-[650px] font-[Lato] text-font-grey leading-[28px] tracking-[0.2px] text-[20px]'>A person who values strong client relationship and brings a unique blend of organisational skills, attention to detail and a positive attitude to work, we want you on our team. As a Sales Executive, willing to be at the forefront of shaping our clients' real estate experiences.</p>


              <h1 className="font-[merriweather] text-[24px] mt-6 py-4" data-aos="fade-up">What We Expect from You</h1>
              <ul className="ml-6" style={{listStyle:'disc'}} data-aos="fade-up">
                  <li className="career-listing-items">Proven sales experience, prefereably in real estate.</li>
                  <li className="career-listing-items">Cultivate strong client relationships through effective communication</li>
                  <li className="career-listing-items">Showcase properties to potential buyers with compelling presentations.</li>
                  <li className="career-listing-items">Expertly negotiate deals for optimal outcomes.</li>
                  <li className="career-listing-items">Ability to thrive in a target-driven environment.</li>
                  <li className="career-listing-items">Stay informed about market trends, pricing and competitor activities.</li>
              </ul>

              <h1 className="font-[merriweather] text-[24px] mt-6 py-4" data-aos="fade-up">What You Gain</h1>
              <ul className="ml-6" style={{listStyle:'disc'}} data-aos="fade-up">
                  <li className="career-listing-items">Competivite commission structure.</li>
                  <li className="career-listing-items">Ongoing training and development opportunities</li>
                  <li className="career-listing-items">A supportive team environment for Professional Growth</li>
              </ul>
Z
          
              {/* <button className="bg-yellow text-[12px] uppercase text-black font-[500] tracking-[1px] mt-8 py-3 px-5 ">Apply now</button> */}
          </div>

          {/* Second div */}
          <div className="max-w-[400px] font-[lato] mx-auto mt-20 min-[1113px]:mt-0" data-aos="fade-up">
              <h1 className="text-[32px] font-[600] uppercase">Apply now</h1>
              <p className="text-[18px] text-font-grey my-2">And we’ll get back to you within 48 hours.</p>
              <hr className="w-[42px] border mt-7" />
              {/* form */}
              <form className="font-[lato] font[16px] text-font-grey">
      
                  <p className="mt-10">Email</p>
                  <input
                    className="career-input-feild"
                    type="Email"
                    name="email"
                  />
                  <p className="mt-4">First Name</p>
                  <input
                    className="career-input-feild"
                    type="text"
                    name="First Name"
                  />
                  <p className="mt-4">Last Name</p>
                  <input
                    className="career-input-feild"
                    type="text"
                    name="Last Name"
                  />
                  <p className="mt-4">Message</p>
                  <textarea
                    className="career-input-message-box"
                    rows="4"
                    cols="50"
                    name="message"
                  />
                  <p className="mt-4">Attach file</p>
                  <input type="file" id="myfile" name="myfile" />
                  <input
                    className="mt-12 bg-yellow px-9 py-2 uppercase font-[500] text-black font-[lato] text-[14px] tracking-[1px]"  
                    type="submit"
                    value="Submit"
                  />
              </form>
          </div>
        </div>

    </>
    );
}

export default Career;